export const NodesModel = Symbol.for('NodesModel');
